





































import Vue, {VueConstructor} from 'vue'
import SelectInput from '../inputs/select.vue'
import {DateTime, DateObject} from 'luxon'

interface IValue {
  value: number
}
export default Vue.extend({
  name: 'SelectField',
  components: {SelectInput},
  props: {
    value: {},
    label: String,
    error: Boolean,
    field: String,
    placeholder: String,
    required: Boolean,
    yearStart: {
      type: Number,
      default: 1900
    },
    yearEnd: {
      type: Number,
      default: (new Date()).getFullYear()
    }
  },
  data () {
    return {
      date: {
        year: null as null | number,
        month: null as null | number,
        day: null as null | number
      },
      months: [
        {value: 1, label: '01'},
        {value: 2, label: '02'},
        {value: 3, label: '03'},
        {value: 4, label: '04'},
        {value: 5, label: '05'},
        {value: 6, label: '06'},
        {value: 7, label: '07'},
        {value: 8, label: '08'},
        {value: 9, label: '09'},
        {value: 10, label: '10'},
        {value: 11, label: '11'},
        {value: 12, label: '12'}
      ]
    }
  },
  methods: {
    onInput (): any {
      this.$emit('input', this.date)
    },
    onFocus (event: any): any {
      this.$emit('focus', event)
    },
    onBlur (event: any): any {
      this.$emit('blur', event)
    },
    setDefaultDate (): void {
      if (this.value) {
        if (typeof this.value !== 'object') {
          return;
        }
        // @ts-ignore
        this.date.year = this.value.year;
        // @ts-ignore
        this.date.month = this.value.month;
        // @ts-ignore
        this.date.day = this.value.day;
      }
    }
  },
  computed: {
    years (): IValue[] {
      const years: IValue[] = []
      for (let i = this.yearEnd; i >= this.yearStart; i--) {
        years.push({value: i})
      }
      return years
    },
    days (): IValue[] {
      let date
      if (this.date.year && this.date.month) {
        date = DateTime.fromObject({year: this.date.year, month: this.date.month});
      }

      let length = date ? date.daysInMonth : 31
      const days: IValue[] = []
      for (let i = 0; i < length; i++) {
        days.push({value: i + 1})
      }
      return days
    },
    isValid (): boolean {
      if (this.date.year && this.date.month && this.date.day) {
        const curentDate = DateTime.local();
        const checkedDate = DateTime.fromObject(this.date as object);
        return checkedDate.isValid && checkedDate.valueOf() < curentDate.valueOf();
      } else {
        return true;
      }
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.setDefaultDate()
    })
  },
  watch: {
    'days.length' () {
      if (this.date.day && this.days.length < this.date.day) {
        this.date.day = this.days.length
      }
    },
    date: {
      handler: function () {
        this.onInput();
      },
      deep: true
    }
  }
})
